import { sendIt } from 'gatsby-plugin-purina-analytics/common/functions';
import React from 'react';
import {
  FaqAccordion as Accordion,
  FaqAccordionItem as AccordionItem,
} from 'src/components/accordion/Accordion';
import RichText from 'src/components/rich_text/RichText';

type Props = {
  node: IStorageFaqSection;
};

const StorageFaqSection = ({ node }: Props) => {
  const { qa_sets: faqList } = node.relationships;

  // If all the accordion sets are draft, don't render.
  if (!faqList || faqList.length === 0) {
    return null;
  }

  const handleActiveKey = (key: string | undefined) => {
    const activeFaqItem = faqList.find(item => item.id === key);
    if (!key || !activeFaqItem) {
      window.history.replaceState({}, '', window.location.pathname);
      return;
    }

    const faqAnalyticsEvent = {
      event: 'module_interaction',
      eventParams: {
        component_id: activeFaqItem.name,
        component_type: 'faq',
        content_name: node.title,
      },
    };

    sendIt(faqAnalyticsEvent);
  };

  return (
    <div
      id={node.component_id}
      data-id={node.drupal_id}
      className="pds-mx-auto pds-w-full pds-max-w-site-container pds-py-4.5 pds-text-surface pds-text-surface-text lg:pds-py-6"
    >
      <div className="pds-mb-5 pds-flex pds-flex-col pds-gap-4">
        {node?.title && <h2 className="pds-mb-0 pds-text-title-lg">{node.title}</h2>}
        {node?.body?.processed && <RichText body={node.body.processed} />}
      </div>

      <Accordion
        id={node.id}
        onValueChange={handleActiveKey}
        options={{ headingLevel: node.title ? 'h3' : 'h2' }}
        accordionList={faqList}
      >
        {faqList.map((faqItem: IStorageFaq) => (
          <AccordionItem
            key={faqItem.id}
            id={faqItem?.component_id ?? ''}
            value={faqItem.id}
            title={faqItem.question as unknown as string}
          >
            <RichText body={faqItem.answer.processed} className="[&_*]:pds-text-body-lg" />
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};

export default StorageFaqSection;
